import { render } from "./perviewCanvas.vue?vue&type=template&id=1a574d3c&scoped=true"
import script from "./perviewCanvas.vue?vue&type=script&lang=js"
export * from "./perviewCanvas.vue?vue&type=script&lang=js"

import "./perviewCanvas.vue?vue&type=style&index=0&id=1a574d3c&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a574d3c"]])

export default __exports__